module.exports = {
	"ha": "iha",
	"id": 5.1,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q3–2018 Q2",
		"lastYear": "2018",
		"lastQuarter": "2"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 330,
			"height": 390,
			"marginTop": 100,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "Figure 5.1 Estimated Cascade of Care for Interior Health, Year Ending 2018 Q2 <sup style=\"font-size: 10px;\">7</sup>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -85,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -40
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous<br>Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -40
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 97.54224270353302,
						"dataLabels": {
							"enabled": true,
							"format": "635"
						}
					},
					{
						"y": 79.87711213517666,
						"dataLabels": {
							"enabled": true,
							"format": "520"
						}
					},
					{
						"y": 76.036866359447,
						"dataLabels": {
							"enabled": true,
							"format": "495"
						}
					},
					{
						"y": 69.89247311827957,
						"dataLabels": {
							"enabled": true,
							"format": "455"
						}
					},
					{
						"y": 53.3026113671275,
						"dataLabels": {
							"enabled": true,
							"format": "347"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -2.457757296466978,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.11023622047244,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.807692307692313,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.080808080808078,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -23.73626373626374,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "<br>n=651"
			}
		],
		"dataTable": {
			"Overall HA": [
				651,
				635,
				520,
				495,
				455,
				347
			]
		}
	},
	"callback": "C:\\Users\\Rafael\\Projects\\cfenet.ubc.ca-qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_5_1.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_iha_5_1.json
// module id = 233
// module chunks = 0